import { sessionStorageAdapter } from '@/service/payment/adapters.js'

export function createSourceService(sourceAdapter = sessionStorageAdapter) {
    const setItem = (value) => sourceAdapter.set(value)

    const getItem = () => sourceAdapter.get()

    const removeItem = () => sourceAdapter.remove()

    const getValue = () => {
        return  getItem()
    }

    return { setItem, getItem, removeItem, getValue }
}

export const paymentFlowSource = createSourceService()